import { render } from "./DocView.vue?vue&type=template&id=2770ddab"
import script from "./DocView.vue?vue&type=script&lang=js"
export * from "./DocView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__